import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';
import { VisitCreateOutOfScheduleCommand } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { dispatchSnackbarPositiveEvent, PreventPrompt, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { useCurrentPractitionerConfidentialityMode } from '~libs.shared.account';
import { visitPaths } from '~libs.desktop.shared.paths';

import { visitTranslationKeys } from '../../../translations';

export const useCreateAppointmentOutOfSchedule = (
   patientId: PatientSimple['id']
): UseCqrsCommandResult<number, void> => {
   const push = useHistoryPushWithBackAction(true);
   const confidentialityLevel = useCurrentPractitionerConfidentialityMode();

   return useCqrsCommand(
      () => {
         const command = new VisitCreateOutOfScheduleCommand();
         command.patientId = patientId!;
         command.confidentialityLevel = confidentialityLevel;
         return command;
      },
      {
         onSuccess: (visitId) => {
            dispatchSnackbarPositiveEvent(visitTranslationKeys.appointmentOutOfSchedule.successMessage);
            push(
               visitPaths.getVisitInterviewPath({
                  params: {
                     visitId: visitId,
                  },
               }),
               {
                  preventPrompt: PreventPrompt.ALWAYS,
               }
            );
         },
      }
   );
};
